import React from 'react';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import MoreBtn from '../../../../shared/components/common/more-btn/MoreBtn';
import CustomTooltip from '../../../../shared/components/common/tooltip/CustomTooltip';

interface BotsActivitySourceMenuProps {
  cloudflareIntegrationId: number | null;
  hasAnyIntegration: boolean;
  disconnectPending: boolean;
  runAnalysisPending: boolean;
  onUploadCsv: () => void;
  onRunAnalysis: () => void;
  onDisconnectCloudflare: () => void;
  onOpenConnect: () => void;
}

export const BotsActivitySourceMenu: React.FC<BotsActivitySourceMenuProps> = ({
  cloudflareIntegrationId,
  hasAnyIntegration,
  disconnectPending,
  runAnalysisPending,
  onUploadCsv,
  onRunAnalysis,
  onDisconnectCloudflare,
  onOpenConnect,
}) => {
  const { t } = useTranslation();

  return (
    <MoreBtn rowId={0}>
      <div className="buttons-list">
        {hasAnyIntegration && (
          <>
            <Button
              id="bots-activity-run-analysis-btn"
              type="button"
              className="action-btn"
              disabled={runAnalysisPending}
              onClick={() => {
                if (!runAnalysisPending) onRunAnalysis();
              }}
            >
              <span
                className={
                  runAnalysisPending ? 'ico--loader ico--xs' : 'ico--refresh ico--xs'
                }
                aria-hidden="true"
              />
            </Button>
            <CustomTooltip
              tooltipText={
                runAnalysisPending ? 'botsActivity.runningAnalysis' : 'botsActivity.runAnalysis'
              }
              targetRef="bots-activity-run-analysis-btn"
            />
          </>
        )}
        {cloudflareIntegrationId === null && (
          <>
            <Button
              id="bots-activity-upload-log-btn"
              type="button"
              className="action-btn"
              onClick={onUploadCsv}
            >
              <span className="ico--clipboard ico--xs" aria-hidden="true" />
            </Button>
            <CustomTooltip
              tooltipText="botsActivity.uploadLog"
              targetRef="bots-activity-upload-log-btn"
            />
          </>
        )}
        <Button
          id="bots-activity-open-connect-btn"
          type="button"
          className="action-btn"
          onClick={onOpenConnect}
        >
          <span className="ico--settings ico--xs" aria-hidden="true" />
        </Button>
        <CustomTooltip
          tooltipText="botsActivity.openConnect"
          targetRef="bots-activity-open-connect-btn"
        />
        {cloudflareIntegrationId !== null && (
          <>
            <Button
              id="bots-activity-disconnect-cf-btn"
              type="button"
              className="action-btn"
              disabled={disconnectPending}
              onClick={() => {
                if (!disconnectPending) onDisconnectCloudflare();
              }}
            >
              <span className="ico--trash ico--xs" aria-hidden="true" />
            </Button>
            <CustomTooltip
              tooltipText={
                disconnectPending ? 'cloudflare.disconnecting' : 'botsActivity.disconnectCloudflare'
              }
              targetRef="bots-activity-disconnect-cf-btn"
            />
          </>
        )}
      </div>
    </MoreBtn>
  );
};

export default BotsActivitySourceMenu;
